export default __webpack_public_path__ + "static/media/PlatenKnife.ec62db22.png";